<template>
  <div class="page-channel">
    <van-image width="100vw" height="auto" fit="cover" :src="bannerImage" />
    <div class="page-channel-content">
      <div class="content-name">{{ questionTitle }}</div>
      <div class="content-des" v-html="questionDesc"></div>
      <div
        class="content-item"
        v-for="(item, index) in state.list"
        :key="index"
      >
        <div class="content-item-title" v-if="isShow(item)">
          <span v-if="item.isRequired == 1" class="item-error">*</span
          >{{ index + 1 }}. {{ item.questionTitle }}
        </div>
        <div class="content-item-content">
          <!-- 手机号 -->
          <van-field
            label-width="0px"
            v-if="item.questionType == 6"
            type="digit"
            class="van-field-custom"
            v-model="item.modelValue"
            placeholder="请输入"
            maxlength="11"
          ></van-field>
          <!-- 多行文本 -->
          <van-field
            v-if="item.questionType == 3 && isShow(item)"
            label-width="0px"
            type="textarea"
            :rows="3"
            class="van-textarea-custom"
            v-model="item.modelValue"
            placeholder="请输入"
          ></van-field>

          <!-- 单行文本 -->
          <van-field
            v-if="item.questionType == 7"
            label-width="0px"
            type="text"
            class="van-field-custom"
            v-model="item.modelValue"
            placeholder="请输入"
          ></van-field>

          <van-uploader
            v-if="item.questionType == 5 && isShow(item)"
            :after-read="afterRead"
            accept="image/*"
            v-model="state.fileList"
            
          />
          <!-- :max-count="1" -->

          <!-- 单选|判断 -->
          <van-radio-group
            v-if="item.questionType == 1 || item.questionType == 4"
            v-model="item.modelValue"
            shape="dot"
          >
            <van-radio
              style="margin-top: 12px"
              v-for="(h, j) in item.optionsList"
              :key="j"
              icon-size="18px"
              :name="h.value"
            >
              <div
                v-if="h.optionType == 'Input'"
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  white-space: nowrap;
                "
              >
                其他
                <van-field
                  @click.stop="handleEmptyClick"
                  style="margin-left: 12px"
                  label-width="0px"
                  v-model="h.otherModalValue"
                  class="van-field-custom"
                  placeholder="请输入"
                ></van-field>
              </div>
              <div v-else>{{ h.label }}</div>
            </van-radio>
          </van-radio-group>

          <!-- 多选 -->
          <van-checkbox-group
            v-model="item.modelValue"
            v-if="item.questionType == 2"
            shape="square"
          >
            <template v-for="(h, j) in item.optionsList" :key="j">
              <van-checkbox
                style="margin-top: 12px"
                icon-size="18px"
                :name="h.value"
              >
                <div
                  v-if="h.optionType == 'Input'"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    white-space: nowrap;
                  "
                >
                  其他
                  <van-field
                    @click.stop="handleEmptyClick"
                    style="margin-left: 12px"
                    label-width="0px"
                    v-model="h.otherModalValue"
                    class="van-field-custom"
                    placeholder="请输入"
                  ></van-field>
                </div>

                <div v-else>{{ h.label }}</div>
              </van-checkbox>
            </template>
          </van-checkbox-group>
        </div>
      </div>
      <div class="footer-wrap">
        <van-button
          class="submit-btn operation-btn"
          style="background: #2672ff"
          @click="handleSumit"
          :loading="state.isSumitLoading"
        >
          提交
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import {
  querySurveySelectSurveyById,
  querySurveyAddDetail,
} from "@/api/user";
import { useRoute } from "vue-router";
import { showToast, showDialog, showLoadingToast, closeToast } from "vant";
import { uploadFile } from "@/api/uploadFile";

// questionType 1单选2多选3多行文本4判断

export default defineComponent({
  name: "RegistrationChannel",

  components: {},

  setup() {
    const route = useRoute();

    const defaultForm = {
      realName: null,
      sex: null,
      grade: null,
      score: null,
      telephone: null,
      isArt: null,
      subject: null,
      oldSchoolName: null,
      createOrg: route?.query?.org,
    };

    const checkPhone = (val) =>
      /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
        val
      );

    const state = reactive({
      list: [],
      form: {
        ...defaultForm,
      },
      fileList:[],
      fileModel: [],
      surveyId: null, // 问卷ID
      applyId: null, // 活动ID
      isSumitLoading: false,
    });

    const bannerImage = ref(null);

    const questionTitle = ref(null);

    const questionDesc = ref(null);

    onMounted(() => {
      state.surveyId = route?.query?.surveyId;
      state.applyId = route?.query?.applyId;
      document.title = "";
      fetchDataList();
    });

    const isShow = (item) => {
      let isBoolean = true;
      if (item.rules) {
        const rules = JSON.parse(item.rules);
        const keys = Object.keys(rules);
        const filter = state.list.filter((h) => h.id == keys?.[0])?.[0];
        if (filter && filter.modelValue == rules[keys?.[0]]) {
          isBoolean = true;
        } else {
          isBoolean = false;
        }
      }
      return isBoolean;
    };

    const fetchDataList = async () => {
      try {
        const result = await querySurveySelectSurveyById({
          id: state.surveyId,
        });
        if (result.code == "00") {
          bannerImage.value = result.data.bannerUrl;
          questionTitle.value = result.data.title;
          questionDesc.value = result.data.describe;
          state.list = result.data.contentDesc.map((item) => {
            return {
              ...item,
              optionsList: item.options
                ? JSON.parse(item.options).map((h) => {
                    return {
                      ...h,
                      otherModalValue: null,
                    };
                  })
                : [],
              modelValue:
                item.questionType == 2 || item.questionType == 5 ? [] : null,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    const afterRead = async (file) => {
      console.log(file);
      console.log(state.fileList);
      try {
        showLoadingToast({
          message: '上传中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        });
        const { data: result } = await uploadFile(file, {
          bsnType: 14,
        });
        console.log(result);
        closeToast();
        if (result.code == "00") {
          state.fileModel.push({
            key: file.objectUrl,
            value: process.env.VUE_APP_BASE_API + '/file/' + result.data?.[0].fileUrl
          })
          showToast(`图片上传成功`);
        } else {
          showToast(`图片上传失败！`);
          state.fileList = state.fileList.filter(item => item.objectUrl !== file.objectUrl)
        }
      } catch (e) {
        closeToast();
        showToast(`图片上传失败！`);
        console.log(e);
        state.fileList = state.fileList.filter(item => item.objectUrl !== file.objectUrl)
      }
    };

    const handleSumit = async () => {
      // if (!state.form.realName) {
      //   showToast("请填写学生姓名");
      //   return;
      // }

      let isPass = true;

      for (let index = 0; index < state.list.length; index++) {
        const item = state.list[index];
        if(item.questionType == 5 && isShow(item)) {
          if(!state.fileList.length) {
            isPass = false;
            showToast(`第${index + 1}题是必填，请检查`);
            return;
          }
        } else {
          if (item.isRequired && (!item.modelValue || !item.modelValue.length) && isShow(item)) {
            isPass = false;
            showToast(`第${index + 1}题是必填，请检查`);
            return;
          }
        }
        
      }

      for (let index = 0; index < state.list.length; index++) {
        const item = state.list[index];
        if(item.questionType == 6 && item.modelValue && !checkPhone(item.modelValue)) {
          isPass = false;
          showToast(`请检查手机号格式是否正确`);
          return;
        } 
      }



      if (!isPass) {
        return;
      }
      

      console.log(state.list);
      const params = {
        applyId: state.applyId,
        surveyId: state.surveyId,
        formData: {},
      };

      const array = state.list.filter(item => isShow(item))

      array.forEach((item) => {
        const answerList = [];
        if(item.questionType == 5) {
          const files = state.fileList;
          console.log('文件===',files)
          for (let i = 0; i < files.length; i++) {
            const el = files[i];
            const filterFile = state.fileModel.filter(l => l.key == el.objectUrl)?.[0]
            if(filterFile) {
              answerList.push({
                answer: filterFile.value,
                answerType:  "Image",
              });
            }
          }
        } else {
          let list = [];
          if (!Array.isArray(item.modelValue)) {
            list = [item.modelValue];
          } else {
            list = item.modelValue;
          }
          
          const filterOption = item.optionsList.filter(
            (option) => option.optionType == "Input"
          )?.[0];

          list.forEach((h, i) => {
            answerList.push({
                answer: h ? h : filterOption?.otherModalValue,
                answerType: h && item.optionsList.length ? "option" : "text",
              });
          });
        }
        
        params.formData[item.id] = answerList;
      });

      try {

        state.isSumitLoading = true
        
        const result = await querySurveyAddDetail(params);
        setTimeout(() => {
          state.isSumitLoading = false
        }, 1000);
        if (result.code == "00") {
          showDialog({
            title: "温馨提示",
            message: "提交成功",
          }).then(() => {
            // on close
            fetchDataList();
            state.fileList = [];
            window.wx.miniProgram.navigateBack();
          });
        } else {
          showToast(result.message);
        }
      } catch (err) {
        showToast("提交失败");
        state.isSumitLoading = false
      }
    };

    const handleEmptyClick = () => {};

    return {
      bannerImage,
      state,
      handleSumit,
      checkPhone,
      questionTitle,
      questionDesc,
      handleEmptyClick,
      isShow,
      afterRead,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-channel {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
  z-index: 99;
  position: absolute;
}

.page-channel-content {
  background: #ffffff;
  border-top-right-radius: 28px;
  border-top-left-radius: 28px;
  width: calc(100% - 40px);
  height: auto;
  padding: 20px;
  margin-top: -28px;
  z-index: 999;
  position: absolute;
  padding-bottom: 64px;
}

.page-channel-content {
}

.content-name {
  font-size: 24px;
  margin-bottom: 8px;
  text-align: center;
  color: #333;
  display: block !important;
  font-weight: 500;
}

.content-des {
  margin: 0 0 32px;
  color: #666;
  display: block;
  font-size: 16px;
  text-align: left;
  white-space: pre-line;
}

.content-item {
  margin-bottom: 40px;
}
.content-item-title {
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 18px;
  text-align: left;
  position: relative;
}

.van-field-custom {
  min-height: 39px !important;
  height: 39px !important;
  background-color: rgba(241, 243, 246, 0.8) !important;
  color: #333 !important;
  font-size: 16px !important;
  line-height: 39px !important;
  padding: 0 !important;
}

.van-field-custom {
  :deep(.van-field__control) {
    padding: 0 12px !important;
    height: 39px !important;
  }
  :deep(.van-field__control:focus) {
    border: 1px solid rgb(38, 114, 255) !important;
    caret-color: rgb(38, 114, 255) !important;
  }
}

.van-textarea-custom {
  background-color: rgba(241, 243, 246, 0.8) !important;
  color: #333 !important;
  font-size: 16px !important;
  padding: 0 !important;
}

.van-textarea-custom {
  :deep(.van-field__control) {
    padding: 12px 12px 0 !important;
  }
  :deep(.van-field__control:focus) {
    border: 1px solid rgb(38, 114, 255) !important;
    caret-color: rgb(38, 114, 255) !important;
  }
}

.footer-wrap {
  display: flex;
  width: 100%;
  justify-content: center;
}

.submit-btn {
  line-height: 1.4;
  width: 180px;
}

.operation-btn {
  background: #2672ff;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  height: 46px;
  line-height: 1.4;
  position: relative;
  text-align: center;
  width: 220px;
}

.item-error {
  color: #ff6d56;
  float: left;
  font-size: 12px;
  font-weight: 500;
  height: 18px;
  left: -1px;
  position: absolute;
  top: 6px;
  transform: translateX(-100%);
  width: 7px;
}

.content-item-content {
  text-align: left;
}
</style>